import { Component, OnInit, SecurityContext } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResponseData } from 'src/app/Model/Base/Response';
import { IataTerminationResponseModel } from 'src/app/Model/IataTerminationResponse.model';
import { TerminationletterService } from 'src/app/Services/TerminationLetter/terminationletter.service';
import { CustomValidators } from 'src/app/Util/CustomValidators';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-termination-letter',
  templateUrl: './termination-letter.component.html',
  styleUrls: ['./termination-letter.component.css']
})
export class TerminationLetterComponent implements OnInit {

  public id: number;
  public buttonBool = true;
  public Url;
  public messageText: string;
  checked: boolean;
  form = new FormGroup({
    message: new FormControl('', [CustomValidators.emptyTextValidator()]),
  });
  get message() { return this.form.get('message'); }

  constructor(private readonly activeRoute: ActivatedRoute,
    protected sanitizer: DomSanitizer,
    private readonly translate: TranslateService,
    private readonly SpinnerService: NgxSpinnerService,
    private readonly Service: TerminationletterService) { }

  ngOnInit(): void {
    this.getUrlCT();
  }

  ngAfterViewInit(){
    this.getUrlCT();
  }

  public async getUrlCT(){
    this.id = this.activeRoute.snapshot.params.id;
    this.SpinnerService.show()
    let rt = await this.Service.getUrlCT(this.id);
    if(rt == null){
      this.buttonBool = false
      Swal.fire({
        icon: "warning",
        title: "No se encontro archivo",
        showConfirmButton: false,
        timer: 3000,
      });
    }
    else{
      let encodedUrl = encodeURIComponent(rt.File)
      this.Url = `https://docs.google.com/gview?url=${encodedUrl}&embedded=true`
      
      let SafeUrl = this.sanitizer.sanitize(SecurityContext.URL, this.Url);
      this.Url = this.sanitizer.bypassSecurityTrustResourceUrl(SafeUrl);
    }

    this.SpinnerService.hide()
  }

  async DocumentPrint() {
    let textoHtml: any
    await this.Service.GetDocumentPrint(this.id).then(async (res) => {
      textoHtml = res;
      window.location.href = textoHtml.File;
    });
  }
  async guardarComentario(){
    let response = new IataTerminationResponseModel();
    let resp: ResponseData;
    response.Id = this.id;
    response.CommentsAgency = this.messageText;
    await this.SpinnerService.show()
    await this.Service.PostCommentsAgency(response).then(res => {
      resp = res;
    })
    await this.SpinnerService.hide();
     if (resp.head.status.toLowerCase() == 'true') {
       await Swal.fire({
         icon: 'success',
         text: this.translate.instant('Request.Messages.Success'),
         showConfirmButton: false,
         timer: 2000
       })
     }
     else {
       await Swal.fire({
         title: 'Error!',
         text: resp.head.error.description,
         icon: 'error'
       }
       )
     }

     this.messageText = null;
     this.checked = false;
  }

}
